import React, { useCallback } from 'react';
import { Typography } from '@material-ui/core';
import { ScheduleRow } from '../ScheduleRow';
import { useGetSchedules } from '../../../../hooks/data/schedules';
import Loading from '../../../../components/Loading';

const BlockedScheduleTable: React.FC = () => {
  const { data, status } = useGetSchedules({
    available: false,
  });

  const getMainContent = useCallback(() => {
    if (status === 'loading') {
      return <Loading />;
    }

    if (status !== 'success') {
      return <p>Erro ao buscar as restrições de horários. Tente novamente</p>;
    }

    if (data?.length === 0) {
      return (
        <Typography>
          Você não possui restrições de horários cadastradas.
        </Typography>
      );
    }

    return data?.map(row => <ScheduleRow key={row.id} schedule={row} />);
  }, [data, status]);

  return (
    <>
      <Typography variant="h5">Horários não disponíveis</Typography>
      {getMainContent()}
    </>
  );
};

export { BlockedScheduleTable };
